import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router";
import { trpc } from "../../app/trpc.js";
import { Notice, Screen, Spinner } from "../../ui/index.js";

/** Публичная страница статуса заявки Meta на удаление данных: `/data-deletion/:code` (ссылку отдаём в ответе колбэка). */
export function DataDeletionStatusPage() {
  const { t, i18n } = useTranslation();
  const { code = "" } = useParams();
  const q = useQuery(trpc.instagram.deletionStatus.queryOptions({ code }, { retry: false }));
  const fmt = (d: Date | null) =>
    d ? new Intl.DateTimeFormat(i18n.language === "sr-Latn" ? "sr-Latn-RS" : i18n.language, { dateStyle: "medium", timeStyle: "short" }).format(d) : "–";
  return (
    <Screen>
      <h1 className="mb-4 text-2xl font-semibold text-ink">{t("deletion.title")}</h1>
      {q.isPending ? (
        <Spinner />
      ) : q.isError ? (
        <Notice kind="error">{t("deletion.notFound")}</Notice>
      ) : (
        <div className="space-y-2 text-sm">
          <div>
            {t("deletion.code")}: <code className="rounded bg-slate-100 px-1">{q.data.code}</code>
          </div>
          <div>
            {t("deletion.status")}: <strong>{t(`deletion.statuses.${q.data.status}`)}</strong>
          </div>
          <div>
            {t("deletion.received")}: {fmt(q.data.createdAt)}
          </div>
          <div>
            {t("deletion.completed")}: {fmt(q.data.completedAt)}
          </div>
          {q.data.status === "done" && <p className="pt-2 text-ink-2">{t("deletion.note")}</p>}
        </div>
      )}
    </Screen>
  );
}
